function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
var HudLayer = require('../hud-layer');
var FortificationOverlayTemplate = require('./fortification.template');
var SaitoOverlay = require('./../../../../../lib/saito/ui/saito-overlay/saito-overlay');
var FortificationOverlay = /*#__PURE__*/function () {
  function FortificationOverlay(app, mod) {
    _classCallCheck(this, FortificationOverlay);
    this.app = app;
    this.mod = mod;
    this.overlay = new SaitoOverlay(this.app, this.mod, false);
  }
  return _createClass(FortificationOverlay, [{
    key: "hide",
    value: function hide() {
      this.overlay.hide();
      return;
    }
  }, {
    key: "pullHudOverOverlay",
    value: function pullHudOverOverlay() {
      HudLayer.pullHudOverOverlay.call(this);
    }
  }, {
    key: "pushHudUnderOverlay",
    value: function pushHudUnderOverlay() {
      HudLayer.pushHudUnderOverlay.call(this);
    }
  }, {
    key: "render",
    value: function render(mobj) {
      var units_to_move = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      var selectUnitsInterface = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
      var finishAndFortify = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
      var unfortification_mode = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 0;
      var his_self = this.mod;
      if (!mobj.unmoved_units) {
        mobj.unmoved_units = [];
      }
      if (!mobj.moved_units) {
        mobj.moved_units = [];
      }

      //
      // create list of figures in each space
      //
      var moved_units = mobj.moved_units;
      var unmoved_units = mobj.unmoved_units;
      var destination_units = [];
      this.units_to_move = units_to_move || [];
      this.selectUnitsInterface = selectUnitsInterface;
      this.finishAndFortify = finishAndFortify;
      this.overlay.show(FortificationOverlayTemplate(mobj, his_self));
      this.pushHudUnderOverlay();
      if (unfortification_mode == 1) {
        document.querySelector('.fortification-from').innerHTML = 'Under Seige';
        document.querySelector('.fortification-to').innerHTML = 'Field Battle';
        document.querySelector('.fortification-submit-button').innerHTML = 'Confirm and Join Battle';
      }
      this.attachEvents(mobj);
    }
  }, {
    key: "attachEvents",
    value: function attachEvents(mobj) {
      var _this = this;
      var his_self = this.mod;
      var units_to_move = this.units_to_move || [];
      var space = his_self.game.spaces[mobj.spacekey];
      document.querySelectorAll('.fortification-overlay .fortification-unit.option').forEach(function (el) {
        el.onclick = function (e) {
          e.stopPropagation();
          var parts = e.currentTarget.id.split('-');
          var faction = parts[0];
          var idx = parseInt(parts[1], 10);
          if (!faction || Number.isNaN(idx) || !space || !space.units[faction]) {
            return;
          }
          var selected = -1;
          for (var z = 0; z < units_to_move.length; z++) {
            if (units_to_move[z].faction === faction && parseInt(units_to_move[z].idx, 10) === idx) {
              selected = z;
              break;
            }
          }
          if (selected >= 0) {
            units_to_move.splice(selected, 1);
          } else {
            var unitno = 0;
            for (var i = 0; i < units_to_move.length; i++) {
              var selected_unit = space.units[units_to_move[i].faction] && space.units[units_to_move[i].faction][units_to_move[i].idx];
              if (selected_unit && selected_unit.army_leader == false) {
                unitno++;
              }
            }
            if (unitno >= 4) {
              alert('Max 4 Units Permitted in Fortification');
              return;
            }
            units_to_move.push({
              faction: faction,
              idx: idx,
              type: space.units[faction][idx].type
            });
          }
          if (typeof _this.selectUnitsInterface === 'function') {
            _this.selectUnitsInterface(his_self, units_to_move, _this.selectUnitsInterface, _this.finishAndFortify);
          }
        };
      });
      var submit = document.querySelector('.fortification-overlay .fortification-submit-button');
      if (submit) {
        submit.onclick = function (e) {
          e.stopPropagation();
          _this.hide();
          if (typeof _this.finishAndFortify === 'function') {
            _this.finishAndFortify(his_self, units_to_move, _this.selectUnitsInterface, _this.finishAndFortify);
          }
        };
      }
    }
  }]);
}();
module.exports = FortificationOverlay;